<script>
import { mapGetters } from "vuex"
const bikentapedia = require("@/docs/bikentapedia.json")

export default {
  name: "BikentapediaMixin",
  beforeMount() {
    this.loadArticles(this.currentLocale)
  },
  data() {
    return {
      articles: {},
    }
  },
  computed: {
    ...mapGetters(["currentLocale"]),
  },
  methods: {
    loadArticles(locale) {
      if (!locale) return
      this.articles = this.$_.keyBy(bikentapedia[locale], "id") || []
    },
  },
  watch: {
    currentLocale(locale) {
      this.loadArticles(locale)
    },
  },
}
</script>
